/* @generated from adl module common.db */

import * as ADL from './../runtime/adl';

export interface DbTable {
  tableName: string;
  withIdPrimaryKey: boolean;
  withPrimaryKey: string[];
  indexes: string[][];
  uniquenessConstraints: string[][];
  extraSql: string[];
  label: string[];
}

export function makeDbTable(
  input: {
    tableName?: string,
    withIdPrimaryKey?: boolean,
    withPrimaryKey?: string[],
    indexes?: string[][],
    uniquenessConstraints?: string[][],
    extraSql?: string[],
    label?: string[],
  }
): DbTable {
  return {
    tableName: input.tableName === undefined ? "" : input.tableName,
    withIdPrimaryKey: input.withIdPrimaryKey === undefined ? false : input.withIdPrimaryKey,
    withPrimaryKey: input.withPrimaryKey === undefined ? [] : input.withPrimaryKey,
    indexes: input.indexes === undefined ? [] : input.indexes,
    uniquenessConstraints: input.uniquenessConstraints === undefined ? [] : input.uniquenessConstraints,
    extraSql: input.extraSql === undefined ? [] : input.extraSql,
    label: input.label === undefined ? [] : input.label,
  };
}

const DbTable_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"tableName","default":{"kind":"just","value":""},"name":"tableName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"withIdPrimaryKey","default":{"kind":"just","value":false},"name":"withIdPrimaryKey","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"withPrimaryKey","default":{"kind":"just","value":[]},"name":"withPrimaryKey","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"indexes","default":{"kind":"just","value":[]},"name":"indexes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[],"serializedName":"uniquenessConstraints","default":{"kind":"just","value":[]},"name":"uniquenessConstraints","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}]}},{"annotations":[],"serializedName":"extraSql","default":{"kind":"just","value":[]},"name":"extraSql","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"label","default":{"kind":"just","value":[]},"name":"label","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}}]}},"name":"DbTable","version":{"kind":"nothing"}}};

export const snDbTable: ADL.ScopedName = {moduleName:"common.db", name:"DbTable"};

export function texprDbTable(): ADL.ATypeExpr<DbTable> {
  return {value : {typeRef : {kind: "reference", value : snDbTable}, parameters : []}};
}

/**
 * Field level annotation to override the name of the
 * database column.
 */
export type DbColumnName = string;

const DbColumnName_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"Field level annotation to override the name of the\ndatabase column.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbColumnName","version":{"kind":"nothing"}}};

export const snDbColumnName: ADL.ScopedName = {moduleName:"common.db", name:"DbColumnName"};

export function texprDbColumnName(): ADL.ATypeExpr<DbColumnName> {
  return {value : {typeRef : {kind: "reference", value : snDbColumnName}, parameters : []}};
}

/**
 * Field or type level annotation to override the type of the
 * database column.
 */
export type DbColumnType = string;

const DbColumnType_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"Field or type level annotation to override the type of the\ndatabase column.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbColumnType","version":{"kind":"nothing"}}};

export const snDbColumnType: ADL.ScopedName = {moduleName:"common.db", name:"DbColumnType"};

export function texprDbColumnType(): ADL.ATypeExpr<DbColumnType> {
  return {value : {typeRef : {kind: "reference", value : snDbColumnType}, parameters : []}};
}

/**
 * Field level annotation specifying the raw SQL `DEFAULT` clause for the
 * column, emitted verbatim by the SQL generator (e.g. "now()", "false",
 * "'GBP'::text"). Use the value as Postgres stores it in column_default so
 * the generated schema matches an existing migration exactly.
 */
export type DbDefault = string;

const DbDefault_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"Field level annotation specifying the raw SQL `DEFAULT` clause for the\ncolumn, emitted verbatim by the SQL generator (e.g. \"now()\", \"false\",\n\"'GBP'::text\"). Use the value as Postgres stores it in column_default so\nthe generated schema matches an existing migration exactly.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbDefault","version":{"kind":"nothing"}}};

export const snDbDefault: ADL.ScopedName = {moduleName:"common.db", name:"DbDefault"};

export function texprDbDefault(): ADL.ATypeExpr<DbDefault> {
  return {value : {typeRef : {kind: "reference", value : snDbDefault}, parameters : []}};
}

/**
 * Declaration level annotation naming the Postgres schema a table belongs to.
 * Tracking metadata only: the SQL generator (deno/adl-tools/gen-sqlschema.ts)
 * does not read this yet — it emits unqualified table names into the default
 * schema. It records, in ADL, that a set of tables lives in a dedicated schema
 * whose DDL is owned outside ADL codegen — e.g. the `ledger` schema (see
 * ferovinum.ledger.db), created by PostgresStore.kt + Flyway.
 */
export type DbSchema = string;

const DbSchema_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"Declaration level annotation naming the Postgres schema a table belongs to.\n\nTracking metadata only: the SQL generator (deno/adl-tools/gen-sqlschema.ts)\ndoes not read this yet — it emits unqualified table names into the default\nschema. It records, in ADL, that a set of tables lives in a dedicated schema\nwhose DDL is owned outside ADL codegen — e.g. the `ledger` schema (see\nferovinum.ledger.db), created by PostgresStore.kt + Flyway.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbSchema","version":{"kind":"nothing"}}};

export const snDbSchema: ADL.ScopedName = {moduleName:"common.db", name:"DbSchema"};

export function texprDbSchema(): ADL.ATypeExpr<DbSchema> {
  return {value : {typeRef : {kind: "reference", value : snDbSchema}, parameters : []}};
}

/**
 * Field level annotation to indicate that a column value
 * is generated, and hence need not be requested from or edited
 * by a user.
 */
export type DbColumnGenerated = null;

const DbColumnGenerated_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"Field level annotation to indicate that a column value\nis generated, and hence need not be requested from or edited\nby a user.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}},"name":"DbColumnGenerated","version":{"kind":"nothing"}}};

export const snDbColumnGenerated: ADL.ScopedName = {moduleName:"common.db", name:"DbColumnGenerated"};

export function texprDbColumnGenerated(): ADL.ATypeExpr<DbColumnGenerated> {
  return {value : {typeRef : {kind: "reference", value : snDbColumnGenerated}, parameters : []}};
}

/**
 * A reference for a database stored value, referenced by a
 * string primary key.
 */
export type DbKey<_T> = string;

const DbKey_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"A reference for a database stored value, referenced by a\nstring primary key.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"newtype_","value":{"typeParams":["T"],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"DbKey","version":{"kind":"nothing"}}};

export const snDbKey: ADL.ScopedName = {moduleName:"common.db", name:"DbKey"};

export function texprDbKey<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<DbKey<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.db",name : "DbKey"}}, parameters : [texprT.value]}};
}

/**
 * A reference for a database stored value, referenced by an integer
 * (bigint) primary key. The integer analogue of DbKey: a field typed
 * `DbId<Entity>` becomes a `bigint` foreign key to the Entity table's
 * primary key. The SQL generator emits the matching FK constraint,
 * schema-qualified to wherever the referenced table lives.
 */
export type DbId<_T> = number;

const DbId_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"A reference for a database stored value, referenced by an integer\n(bigint) primary key. The integer analogue of DbKey: a field typed\n`DbId<Entity>` becomes a `bigint` foreign key to the Entity table's\nprimary key. The SQL generator emits the matching FK constraint,\nschema-qualified to wherever the referenced table lives.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"newtype_","value":{"typeParams":["T"],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}}},"name":"DbId","version":{"kind":"nothing"}}};

export const snDbId: ADL.ScopedName = {moduleName:"common.db", name:"DbId"};

export function texprDbId<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<DbId<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.db",name : "DbId"}}, parameters : [texprT.value]}};
}

/**
 * A value of type T along with a unique db identifier
 */
export interface WithDbId<T> {
  id: DbKey<T>;
  value: T;
}

export function makeWithDbId<T>(
  input: {
    id: DbKey<T>,
    value: T,
  }
): WithDbId<T> {
  return {
    id: input.id,
    value: input.value,
  };
}

const WithDbId_AST : ADL.ScopedDecl =
  {"moduleName":"common.db","decl":{"annotations":[{"value":"A value of type T along with a unique db identifier\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}}]}},"name":"WithDbId","version":{"kind":"nothing"}}};

export const snWithDbId: ADL.ScopedName = {moduleName:"common.db", name:"WithDbId"};

export function texprWithDbId<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<WithDbId<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "common.db",name : "WithDbId"}}, parameters : [texprT.value]}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "common.db.DbTable" : DbTable_AST,
  "common.db.DbColumnName" : DbColumnName_AST,
  "common.db.DbColumnType" : DbColumnType_AST,
  "common.db.DbDefault" : DbDefault_AST,
  "common.db.DbSchema" : DbSchema_AST,
  "common.db.DbColumnGenerated" : DbColumnGenerated_AST,
  "common.db.DbKey" : DbKey_AST,
  "common.db.DbId" : DbId_AST,
  "common.db.WithDbId" : WithDbId_AST
};
